module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-6-en.4b00e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/technology-1-SD-WAN-img-6-en.png
// module id = +HTy
// module chunks = 0